<div id="bca-choose-extras">
  <h2 class="nes-h3 nes-mb-3">
    {{ "COMPOSE.CHOOSE_EXTRAS.TITLE" | translate }}
  </h2>
  <div>
    <div class="nes-flex nes-flex-col nes-gap-5 nes-mb-5">
      <ng-container
        *ngFor="let addon of selectedProduct.addons; trackBy: trackByIdentifier"
      >
        <bca-product-addon
          [addon]="addon"
          [routeLoading]="
            (routeLoading$ | async) &&
            selectedProduct.identifier === ProductIdentifier.Traject
          "
          (selected)="onAddonSelected(addon, $event)"
        >
        </bca-product-addon>
      </ng-container>
    </div>

    <div class="nes-mb-10">
      <div class="nes-mb-3">
        <div class="nes-flex nes-gap-3">
          <h3 class="nes-h4">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.TITLE" | translate }}
          </h3>
          <nes-tooltip nes-id="dtd-services-tooltip">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_TOOLTIP" | translate }}
          </nes-tooltip>
        </div>
        <p>
          {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.EXPLAINER" | translate }}
        </p>
      </div>

      <div class="nes-flex nes-mb-10">
        <nes-selectable
          #useExtrasButtonTrue
          class="nes-mr-3 nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center"
          id="useExtrasButtonTrue"
          nes-id="useExtrasButtonTrue"
          [label]="'COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.CONFIRM' | translate"
          name="option-yes"
          [checked]="(servicesNotExpanded$ | async)"
          (nesOnClick)="toggleServicesExpandedOld(false)"
        >
          <div class="nes-py-4 nes-text-center">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.CONFIRM" | translate }}
          </div>
        </nes-selectable>

        <nes-selectable
          #useExtrasButtonFalse
          class="nes-w-5/12 sm:nes-w-3/12 nes-flex nes-justify-items-center"
          id="useExtrasButtonFalse"
          nes-id="useExtrasButtonFalse"
          [label]="'COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.DECLINE' | translate"
          name="option-no"
          [checked]="!(servicesNotExpanded$ | async)"
          (nesOnClick)="toggleServicesExpandedOld(true)"
        >
          <div class="nes-py-4 nes-text-center">
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.BUTTON.DECLINE" | translate }}
          </div>
        </nes-selectable>
      </div>
      <ng-container *ngIf="servicesNotExpanded$ | async">
        <div class="nes-mb-3">
          <nes-heading
            tag="h3"
            size="base"
            class="nes-font-bold nes-text-blue nes-m-0"
          >
            {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_TITLE" | translate }}
          </nes-heading>
        </div>
        {{ "COMPOSE.CHOOSE_EXTRAS.SERVICES.OPEN_EXPLAINER" | translate }}

        <div
          id="services"
          class="collapsibleTile__content animated fadeIn nes-mt-5"
        >
          <ng-container
            *ngFor="
              let service of selectedProduct.services;
              let even = even;
              trackBy: trackByIdentifier
            "
          >
            <bca-product-service
              (selected)="onServiceSelected(service, $event)"
              [service]="service"
              [tooltip]="
                'COMPOSE.CHOOSE_EXTRAS.SERVICES.' +
                service.identifier +
                '.TOOLTIP'
              "
              [isEven]="even"
            >
            </bca-product-service>
          </ng-container>
        </div>
      </ng-container>
    </div>

    <div class="lg:nes-hidden" *ngIf="showProductInfo$ | async">
      <nes-highlight-box type="info">
        <ns-product-info (action)="onActionClicked($event)"></ns-product-info>
      </nes-highlight-box>
    </div>
  </div>
</div>
